import { InsuranceFooterState } from '@cp-mx/common';
import { Reducer } from 'redux';

export const insuranceFooterReducer: Reducer<InsuranceFooterState> = (
    state = {
        shown: false,
    },
    action,
) => (action.type === 'hasInsurance' ? action.data : state);
